import { LandingPage } from "./landing/LandingPage.tsx";
import { InvitationDownloadPage } from "./invitation/InvitationDownloadPage.tsx";

export function App() {
  return window.location.pathname === "/invite" ? <InvitationDownloadPage /> : <LandingPage />;
}
